import { PositionOverview } from '../types'
import { Token } from '@/domain/types/Token'
import { SparkRewardCampaign, SparkRewardPill } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'
import { TransactionOverview } from '@/ui/organisms/transaction-overview/TransactionOverview'
import { testIds } from '@/ui/utils/testIds'

export interface BorrowOverviewPanelProps {
  borrowAsset: Token
  currentPositionOverview: PositionOverview
  updatedPositionOverview: PositionOverview | undefined
  relatedCampaigns: SparkRewardCampaign[]
}
export function BorrowOverviewPanel({
  borrowAsset,
  currentPositionOverview,
  updatedPositionOverview,
  relatedCampaigns,
}: BorrowOverviewPanelProps) {
  return (
    <TransactionOverview>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Borrow APY</TransactionOverview.Label>
        <TransactionOverview.ApyChange
          currentApy={currentPositionOverview.borrowAPY}
          updatedApy={updatedPositionOverview?.borrowAPY}
          colorUpdated={false}
          currentApyTestId={testIds.dialog.borrow.borrowApyBefore}
          updatedApyTestId={testIds.dialog.borrow.borrowApyAfter}
        />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Debt</TransactionOverview.Label>
        <TransactionOverview.TokenAmountChange
          token={borrowAsset}
          currentAmount={currentPositionOverview.debt}
          updatedAmount={updatedPositionOverview?.debt}
        />
      </TransactionOverview.Row>
      <TransactionOverview.Row>
        <TransactionOverview.Label>Health factor</TransactionOverview.Label>
        <TransactionOverview.HealthFactorChange
          currentHealthFactor={currentPositionOverview.healthFactor}
          updatedHealthFactor={updatedPositionOverview?.healthFactor}
        />
      </TransactionOverview.Row>
      {relatedCampaigns.length > 0 && (
        <TransactionOverview.Row>
          <TransactionOverview.Label>Extra Rewards</TransactionOverview.Label>
          <TransactionOverview.Generic>
            {relatedCampaigns.map((campaign) => (
              <SparkRewardPill key={campaign.campaignId} {...campaign} />
            ))}
          </TransactionOverview.Generic>
        </TransactionOverview.Row>
      )}
    </TransactionOverview>
  )
}
